import axios from 'axios'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = store.getters.token
    }
    return config
  }, 
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data

    console.log('res', res)
    // 如果自定义状态码不是200，则判断为错误
    if (res.code !== 200) {
      // 对于官网网站，接口失败时不弹框提示，只打印错误信息
      console.error('API Error:', res.message || 'Error')

      // 401: 未登录或token过期
      if (res.code === 401) {
        // 清除token
        store.dispatch('user/resetToken')
        // 不自动刷新页面，避免OAuth2认证过程中的无限循环
        // 由调用方自行处理重定向逻辑
      }

      // 403: 权限不足
      if (res.code === 403) {
        console.warn('权限不足，无法访问')
      }

      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    
    let message = '网络错误，请检查网络连接'
    
    if (error.response) {
      // 服务器返回错误状态码
      const { status, data } = error.response
      
      switch (status) {
        case 401:
          message = '未授权，请重新登录'
          // 清除token
          store.dispatch('user/resetToken')
          // 不自动刷新页面，避免OAuth2认证过程中的无限循环
          // 由调用方自行处理重定向逻辑
          break
        case 403:
          message = '拒绝访问，权限不足'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = data.message || `请求错误: ${status}`
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      message = '网络异常，无法连接到服务器'
    } else {
      // 请求配置错误
      message = error.message
    }

    // 对于官网网站，网络错误时不弹框提示，只打印错误信息
    console.error('Network Error:', message)
    
    return Promise.reject(error)
  }
)

export default service
